// extracted by mini-css-extract-plugin
module.exports = {"rulesGroupContent":"RulesGroupContent_rulesGroupContent__Ic4X6"};